export const getWebhooksUrl = () => '/agency/webhooks';
export const getWebhookUrl = (webhookId: string | number) => `/agency/webhooks/${webhookId}`;
export const getWebhookEventsUrl = () => '/agency/webhooks/new';
export const getWebhookLogsUrl = () => '/agency/webhook_logs';
export const getWebhookLogUrl = (logId: string | number) => `/agency/webhook_logs/${logId}`;
